import {view, css} from '@sail/ui/deprecated';
import {MessageDescriptor, FormattedMessage} from 'react-intl';

/**
 * This file contains the UI for a language availability notice (along with all the strings it can have).
 * Logic for figuring out which notice to display should be at the usage site.
 */

type Props = {
  notice: MessageDescriptor | string;
};

export function AvailabilityNotice({notice}: Props) {
  if (!notice) {
    return null;
  }

  return (
    <view.div
      data-testid="availability-notice"
      css={{
        display: css.value('flex'),
        alignItems: css.value('center'),
        margin: css.value('6px 0px'),
        padding: css.value('12px 20px'),
        border: css.value('none'),
        borderRadius: css.value('0'),
        background: css.value('$color.neutral50'),
        color: css.value('$color.neutral800'),
      }}
    >
      {typeof notice === 'string' ? notice : <FormattedMessage {...notice} />}
    </view.div>
  );
}
